// API Configuration
export const API_BASE_URL = 'https://k1a2nskxl0.execute-api.eu-west-2.amazonaws.com/prod';

// API Endpoints
export const ARTICLES_ENDPOINT = `${API_BASE_URL}/articles`; 